'use client';

import RichText from '@/components/ui/RichText/RichText';
import FormSection from '@/components/forms/FormSection/FormSection';
import { SmartFormBlock } from '@/components/forms/SmartFormBlock';
import { FeedbackProps } from '@/features/feedback/hooks/types';

export default function FeedbackSection({ data }: FeedbackProps) {
  if (!data) return <p>Feedback data not available</p>;

  const { heading, description } = data;

  return (
    <FormSection
      id="feedback-section"
      heading={heading}
      description={description}
      form={
        <SmartFormBlock
          formId="feedback"
          mode="inline"
          template="bare"
          submitLabel={data.btnText}
          renderFooterExtra={(values: { rating?: number }) => {
            const isNegative = values.rating === 0 || values.rating === 1;
            return (
              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  isNegative
                    ? 'max-h-12 opacity-100 lg:max-w-xs'
                    : 'max-h-0 opacity-0 lg:max-w-0'
                }`}
              >
                <RichText styles={data.complaintLink.styles}>
                  {data.complaintLink.content}
                </RichText>
              </div>
            );
          }}
        />
      }
    />
  );
}
